<template>
    <v-container fluid>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p class="display-2 text-sm-center">Lets Chat!</p>
                <v-divider class="my-3"></v-divider>
                <p class="body-1 ma-8">Whether you're a restaurant and want to participate in a pilot, a user with feedback, or just want to say hi,
                send us an email! We'd love to hear from you!</p>
                <div class="mx-8 text-sm-center">
                <v-icon>mdi-email</v-icon>
                <span class="mx-2">info@trylokl.com</span>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Contact"
    }
</script>

<style scoped>

</style>